import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import axios from "axios";
import { API_URL1 } from "../services/url";
import "./Login.css";
import logo from "../images/Logo3.PNG";
import { useAlert } from "react-alert";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [btn_Status, setbtn_Status] = useState("unclick");
  const alert = useAlert();
  const data = {
    email,
    password,
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setbtn_Status("clicked");
    axios
      .post(`${API_URL1}trucker/login`, data)

      .then((response) => {
        if (response.data.success === true) {
          alert.success(response.data.message);

          localStorage.setItem("TruckertokenKey", response.data.token);
          localStorage.setItem("adminid", response.data.user.truck_company_id);
          localStorage.setItem("adminname", response.data.user.name);
          localStorage.setItem("Temail", response.data.user.email);
          localStorage.setItem("phone_no", response.data.user.phone_no);
          localStorage.setItem(
            "trucker_id",
            response.data.user.truck_company_user_id
          );
          localStorage.setItem("company_name", response.data.user.company_name);
          window.location.reload();
          window.location = "/";
          return <div />;
        } else {
          alert.error("Invalid Email or Password", {
            onClose: () => {
              window.location.reload();
            },
          });
        }
      })
      .catch((error) => {
        alert.error("Invalid Email or Password", {
          onClose: () => {
            window.location.reload();
          },
        });
        console.error(error);
      });
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '1040px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '0px',
          backgroundColor: '#ffffff',
          borderRadius: '20px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
          border: '1px solid #e5e7eb',
          overflow: 'hidden'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '56px 32px',
            background: 'linear-gradient(135deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)'
          }}>
            <img src={logo} alt="Rock Pros" style={{ width: 200, height: 'auto', marginBottom: 20 }} />
            <h2 style={{
              fontSize: '32px',
              fontWeight: 800,
              color: '#ffffff',
              margin: 0,
              textAlign: 'center'
            }}>Welcome back!</h2>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.9)',
              marginTop: 8,
              textAlign: 'center'
            }}>Sign in to your trucker portal.</p>
          </div>

          <div style={{ padding: '48px 40px' }}>
            <h1 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#0f172a',
              margin: '0 0 8px 0'
            }}>Sign In</h1>
            <p style={{ fontSize: '14px', color: '#64748b', marginTop: 0, marginBottom: 24 }}>Enter your credentials to continue.</p>

            <form method="POST" onSubmit={(e) => onSubmit(e)} style={{ width: '100%' }}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '8px'
                }}>Email Address</label>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <div style={{ position: 'absolute', left: '16px', color: '#9ca3af', fontSize: '16px', zIndex: 1 }}>
                    <i className="fas fa-envelope"></i>
                  </div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 16px 14px 48px',
                      borderRadius: '10px',
                      border: '1px solid #e5e7eb',
                      fontSize: '15px',
                      backgroundColor: '#f8fafc',
                      color: '#1e293b',
                      outline: 'none',
                      transition: 'all 0.3s ease',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#6366f1';
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.boxShadow = '0 0 0 3px rgba(99,102,241,0.15)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e5e7eb';
                      e.target.style.backgroundColor = '#f8fafc';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '8px'
                }}>Password</label>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <div style={{ position: 'absolute', left: '16px', color: '#9ca3af', fontSize: '16px', zIndex: 1 }}>
                    <i className="fas fa-lock"></i>
                  </div>
                  <input
                    id="password"
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '14px 16px 14px 48px',
                      borderRadius: '10px',
                      border: '1px solid #e5e7eb',
                      fontSize: '15px',
                      backgroundColor: '#f8fafc',
                      color: '#1e293b',
                      outline: 'none',
                      transition: 'all 0.3s ease',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#6366f1';
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.boxShadow = '0 0 0 3px rgba(99,102,241,0.15)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e5e7eb';
                      e.target.style.backgroundColor = '#f8fafc';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>
              </div>

              <button
                type="submit"
                onClick={(e) => onSubmit(e)}
                disabled={btn_Status === 'clicked'}
                style={{
                  width: '100%',
                  padding: '14px 24px',
                  borderRadius: '10px',
                  border: 'none',
                  background: btn_Status === 'clicked' ? '#9ca3af' : 'linear-gradient(135deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)',
                  color: '#ffffff',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: btn_Status === 'clicked' ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: btn_Status === 'clicked' ? 'none' : '0 4px 12px rgba(99,102,241,0.25)',
                  textTransform: 'none',
                  letterSpacing: '0.3px'
                }}
                onMouseEnter={(e) => {
                  if (btn_Status !== 'clicked') {
                    e.target.style.background = 'linear-gradient(135deg, #7d1616 0%, #6b1212 100%)';
                    e.target.style.boxShadow = '0 6px 16px rgba(153, 28, 28, 0.35)';
                    e.target.style.transform = 'translateY(-1px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (btn_Status !== 'clicked') {
                    e.target.style.background = 'linear-gradient(135deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)';
                    e.target.style.boxShadow = '0 4px 12px rgba(153, 28, 28, 0.25)';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                {btn_Status === 'clicked' ? 'Signing in...' : 'Sign In'}
              </button>

              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                <span 
                  onClick={() => {
                    alert.info("Please contact Rockpros Team for password reset assistance.");
                  }}
                  style={{ 
                    color: '#991C1C', 
                    fontWeight: 600, 
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                    e.target.style.color = '#7d1616';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                    e.target.style.color = '#991C1C';
                  }}
                >
                  Forgot Password?
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
